import { useState, useEffect } from "react";

const useSpinOffset = (spinDurationMs) => {
  const [spinOffsetMs, setSpinOffsetMs] = useState();

  useEffect(() => {
    setSpinOffsetMs(Date.now() % spinDurationMs);
  }, [spinDurationMs]);

  return spinOffsetMs;
};

export default useSpinOffset;
